import React, { useState } from 'react';
import Dialog from '../Dialog/Dialog';
import Input from '../Input/Input';
import { TextButton } from '../Button';
import './InviteDialog.css';

interface InviteDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onInvite: (email: string) => void;
  isLoading?: boolean;
}

const InviteDialog: React.FC<InviteDialogProps> = ({
  isOpen,
  onClose,
  onInvite,
  isLoading = false
}) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | undefined>();
  const [isSubmitted, setIsSubmitted] = useState(false);

  const validateEmail = (email: string): string | undefined => {
    if (!email.trim()) {
      return 'Email is required';
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      return 'Email is invalid';
    }
    return undefined;
  };

  const handleInvite = () => {
    setIsSubmitted(true);
    const validationError = validateEmail(email);
    setError(validationError);
    
    if (!validationError) {
      onInvite(email.trim());
    }
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value);
    if (isSubmitted) {
      setError(validateEmail(e.target.value));
    }
  };

  const headerActions = (
    <div className="dialog-header-actions">
      <TextButton 
        variant="secondary" 
        onClick={onClose}
        disabled={isLoading}
        size="small"
      >
        Cancel
      </TextButton>
      <TextButton
        variant="primary"
        onClick={handleInvite}
        disabled={isLoading}
        isLoading={isLoading}
        size="small"
      >
        Invite
      </TextButton>
    </div>
  );

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Invite Team Member"
      headerActions={headerActions}
      showCloseButton={false}
    >
      <div className="invite-dialog-content">
        <Input
          label="Email"
          type="email"
          value={email}
          onChange={handleEmailChange}
          placeholder="Enter email address"
          error={error}
          disabled={isLoading}
          required
        />
      </div>
    </Dialog>
  );
};

export default InviteDialog; 